export enum LocalStorage {
  InvestmentAccount = 'lastSelectedInvestmentAccount',
}
